<script setup lang="ts">
import { ref } from 'vue';
import { useAuthStore } from '../../stores';
import { TEXT } from '../../configs/text';
import Input from '../../components/Form/Input.vue';
import LoginPanel from '../../components/Form/LoginPanel.vue';
import Submit from '../../components/Form/Submit.vue';
import { useI18n } from 'petite-vue-i18n';

const auth = useAuthStore()
const username = ref<string>('')
const code = ref<string>('')
const errorCode = ref<string | undefined>()

async function handleSubmit() {
    errorCode.value = ''
    errorCode.value = await auth.studentLogin(username.value, code.value)
}

const { t } = useI18n()
</script>

<template>
    <LoginPanel>
        <form @submit.prevent="handleSubmit">
            <Input type="tel" required :placeholder="t(TEXT.username)" v-model="username" />
            <Input type="tel" required :placeholder="t(TEXT.access_code)" v-model="code" />
            <div v-if="errorCode" class="text-red-500 text-center">{{ t(errorCode) }}</div>
            <Submit />
        </form>
    </LoginPanel>
</template>